import React from 'react';
import DataList from '../DataList';
import ApiConfigFactory from '../../configurations/ApiConfigFactory';

const GlucoseLogs = ({ admissionId, disableEdit }) => {
  const dlConfig = new ApiConfigFactory(
    'admissions/glucose-logs',
    'Glucose Logs',
    'admission_id',
    admissionId
  );

  dlConfig.title = `Glucose Logs for Admission: ${admissionId}`;
  dlConfig.allowAdd = !disableEdit;
  dlConfig.allowEdit = !disableEdit;
  dlConfig.path = '/admission-card/glucose-logs';
  dlConfig.defaultSortFieldId = 'log_id';
  dlConfig.conditionalStyles = {
    "Glucose Level": {
      "type": "number",
      "conditions": {
        "range": [
          { "min": 0, "max": 3.9, "style": {"color": "white", "backgroundColor": "red"} },
          { "min": 4, "max": 7, "style": {"color": "black", "backgroundColor": "white"} },
          { "min": 7.1, "max": 999, "style": {"color": "white", "backgroundColor": "red"} }
        ]
      }
    }
  };

  dlConfig.addStaticDropdownField( {
    name: 'reading_type',
    options:[
        { id: 'fasting', name: 'Fasting' },
        { id: 'pre-meal', name: 'Pre-meal' },
        { id: 'post-meal', name: 'Post-meal' },
        { id: 'random', name: 'Random' }

    ],
});

  dlConfig
    .addField({ name: 'log_id', label: 'Log ID', type: 'number', identifier: true, disabled: true })
    .addField({ name: 'admission_id', label: 'Admission ID', type: 'number', defaultValue: admissionId, visible: false })
    .addField({ name: 'log_date', label: 'Date & Time', type: 'datetime-local', required: true, defaultValue: new Date().toISOString().slice(0, 16) })
    .addField({ name: 'glucose_level', label: 'Glucose Level', type: 'number', step: '0.1', required: true })
    .addField({ 
      name: 'reading_type', 
      label: 'Reading Type', 
      type: 'dropdown', 
      required: true,
    });

  dlConfig
    .addColumn({ id: 'log_date', name: 'Date & Time', selector: (row) => row.log_date, type: 'datetime', sortable: true })
    .addColumn({ name: 'Glucose Level', selector: (row) => `${row.glucose_level} mmol/L`, type: 'text', sortable: true })
    .addColumn({ name: 'Reading Type', selector: (row) => row.reading_type, type: 'text', sortable: true });

  return <DataList apiConfig={dlConfig} columns={dlConfig.columns} />;
};

export default GlucoseLogs;
